module.exports = [
  {
    image: "igor-yana",
    author: "Игорь и Яна",
    date: "23.05.2018",
    text:
      "Работа выполнена качественно, претензий никаких, даже придраться не к чему. Присоединяюсь к другим отзывам - действительно порадовали очень вежливые консультанты. Особенно мне, как человеку ничего не понимающему в дизайне) подсказали, показали все что нужно и как будет выглядеть в конечном итоге. Когда увидели конверты в жизни они были ещё красивее чем на фото) молодцы ребята!",
  },
  {
    image: "niko-anastasiya",
    author: "Николай и Анастасия",
    date: "01.04.2019",
    text:
      "Думаю что я не одна так нервничаю за то как пройдёт моя свадьба... потому что это самый особенный день в моей жизни! Все время кажется, что что-нибудь пойдёт не так, но в valeur я уверена! Ребята сделали все так как мы хотели, несмотря на то что невеста очень капризная, безумно красивые пригласительные, а гости даже боялись их открывать! Все очень качественно и красиво спасибо большое",
  },
  {
    image: "igor-dariya",
    author: "Игорь и Дарья",
    date: "21.07.2020",
    text:
      "Хочу поблагодарить за работу сотрудников valeur. Очень приятно было работать с вами. Сколько бы вопросов я не задавала они отвечали очень вежливо. Честно сказать я даже не представляла как будут выглядеть мои пригласительные, но хотелось чего-то необычного. Огромное спасибо вашей команде за такую красоту, оставим себе на память, чудесные пригласительные.",
  },
  {
    image: "michael-anastasiya",
    author: "Михаил и Анастасия",
    date: "06.07.2020",
    text:
      "Очень сложно было выбрать среди многочисленных компаний, но почему-то лично у меня valeur вызвало наибольшее расположение. Очень приятные мастера , помогли мне сделать сюрприз будущей. Очень качественно, цвета яркие и приятно держать в руках. Жена довольна, удалось ее удивить) Спасибо вам, девочки, не знаю что бы без вас делал!",
  },
  {
    image: "anthony-anna",
    author: "Антон и Анна",
    date: "14.02.2020",
    text:
      "Добрый день. Наконец-то нашла время выразить благодарность за наши ригласительные. Ничего лишнего, эстетика, строгость, аккуратность - все так, как мы хотели. Вы внесли поистине огромный вклад в важный для нас день. Очень приятно когда на торжество гостей приглашаешь именно в такой форме, всех очень удивила ваша работа. Желаем вам творческих успехов!",
  },
  {
    image: "vladimir-kseniya",
    author: "Владимир и Ксения",
    date: "22.04.2020",
    text:
      "Добрый вечер, хочу поблагодарить вас за наш комплект для фотосессии! Я вообще о таком даже не знала)) но мне это так помогло. В связи с карантином у нас не было гостей, зато было наше пригласительное и красивая съемка. Спасибо, что сделали наш день замечательным даже в такое непростое время!",
  },
  {
    image: "constantine-nadezhda",
    author: "Константин и Надежда",
    date: "13.09.2018",
    text:
      "Нам все очень понравилось! С самого начала я не имела представления, что конкретно хочу. Спасибо Даше, что разработала нам индивидуальный дизайн и сделала пригласительные мечты! Все выполнено качественно, спасибо, что подошли с такой ответственностью к нашей свадьбе!",
  },
];
